// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { CopyMenu } from './copy-menu'
import { nothing } from '$func/utils'

const COMPONENT_ID = 'copyMenu'

interface Prop {
  text: string
  onDone?: () => unknown
}

export const showCopyMenu = (
  { text, onDone }: Prop,
  preventBackClick = false,
) =>
  addModal({
    id: COMPONENT_ID,
    props: { onDone: onDone || nothing, text },
    preventBackClick,
  })

export default {
  [COMPONENT_ID]: { Component: CopyMenu },
}
